import React from "react";
import { useParams, useHistory } from "react-router-dom";
import firebaseApi from "../../apis/firebaseApi";
import dateHelpers from "../../helpers/dateHelpers";
import TextToggle from "../common/TextToggle";
import { FrameContext } from "../../contexts/FrameContext";
import schedulingHelpers from "../../helpers/schedulingHelpers";

const AppointmentReschedule = () => {
    const { scheduleId } = useParams();
    const { companyId, agentId } = React.useContext(FrameContext);
    const [schedule, setSchedule] = React.useState();
    const [agent, setAgent] = React.useState();

    const [bookedSchedules, setBookedSchedules] = React.useState([]);
    const [isToday, setIsToday] = React.useState(true);
    const [selectedRadio, setSelectedRadio] = React.useState('Today');
    let history = useHistory();

    React.useEffect(() => {
        if (!companyId || !scheduleId) return;
        firebaseApi.getAgentSchedule(companyId, scheduleId, data => {
            if (data.empty) {
                history.push(`/agent`);
            }
            setSchedule({ ...data.data(), id: data.id })
        });

        firebaseApi.getAgent(companyId, agentId, data => {
            setAgent({ ...data.data(), id: data.id })
        });

        firebaseApi.getPendingAgentSchedules(companyId, agentId, data => {
            let items = [];
            data.forEach(x => items.push({ ...x.data(), id: x.id }));
            setBookedSchedules(items);
        })
    }, [companyId, scheduleId]);

    const onScheduleCallClick = (schedule) => {
        let data = { schedule: schedule };
        firebaseApi.updateCompanySchedule(companyId, scheduleId, data, response => {
            history.push(`/appointment/${scheduleId}`)
        });
    }

    const onTextToggled = (isChecked, value) => {
        setSelectedRadio(value);
        setIsToday(value === 'Today');
    }

    const getDays = () => {
        if (selectedRadio === 'Today')
            return [new Date()];
        else if (selectedRadio === 'This Week')
            return schedulingHelpers.getAvailableDays(agent.workHours.data, 3, agent.gmtOffset);
        else
            return schedulingHelpers.getAvailableDays(agent.workHours.data, 3, agent.gmtOffset, true);

        // return isToday
        //     ? [new Date()]
        //     : schedulingHelpers.getAvailableDays(agent.workHours.data, 3, agent.gmtOffset)
    }

    const getAvailableTimes = day => {
        return schedulingHelpers.getAvailableTimes(day, agent, bookedSchedules, scheduleBreakdown);
    }

    const getBrokenDownSchedule = () => {
        return schedulingHelpers.getSchedulingBreakdown(agent.workHours, agent.gmtOffset, selectedRadio === 'Next Week');
    }

    let scheduleBreakdown = getBrokenDownSchedule();
    if (!schedule || !agent) return null;

    return (
        <div className="cts-scheduled">
            <h2>Rescheduling Your Appointment</h2>
            <div className="cts-schedule-date-container">
                <div className="cts-calendar-container">
                    <i className="fas fa-calendar-star" />
                </div>
                <div className="cts-date-container">
                    {/* Today<br /> */}
                    <b>{dateHelpers.getScheduleDay(new Date(schedule.schedule.startTime * 1000))}</b><br />
                    {dateHelpers.getTimeString(new Date(schedule.schedule.startTime * 1000))} - {dateHelpers.getTimeString(new Date(schedule.schedule.endTime * 1000), true)}
                </div>
            </div>
            <hr />
            <div className="cts-schedule">
                <div>
                    <TextToggle
                        name="cts-schedule-name-toggle"
                        r1Text="This Week"
                        r2Text="Today"
                        r3Text="Next Week"
                        value={selectedRadio}
                        onChange={onTextToggled}
                    />
                </div>
                <hr />
                <div className="cts-schedule-days">
                    {getDays().map(day =>
                        <div>
                            <div className="cts-schedule-day">
                                {dateHelpers.getScheduleDay(day)}
                            </div>
                            <div>
                                {getAvailableTimes(day).schedules.map((x, i) =>
                                    <div key={i} className="cts-schedule-slot">
                                        <div className="cts-schedule-slot-time"><i className="fas fa-clock" /> {x.timeString}</div>
                                        <button onClick={() => onScheduleCallClick(x)} type="button" className="cts-btn-schedule"><i className="far fa-calendar-plus" /> Schedule Call</button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default AppointmentReschedule;